import { ComponentHelper } from "../../core/util/componentHelper";
import { FieldInstance } from "../../core/components/field";
import { DropDownList } from "../../core/components/dropDownList";
import { NodaPeriodeNumericTextBox } from "../../core/components/nodaPeriodeNumericTextBox";
import { Helper } from "../../core/util/helper";
import { AppHelper } from "../../appHelper";
import { Button } from "../../core/components/button";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import EditRecurrenceSchemaVersion, { EditReccurenceSchemaProps, EditRecurrenceSchemaEntity } from "./editRecurrenceSchemaVersion";
import { IsNumericTextBox } from "../../core/components/isNumericTextBox";
import { CheckBox } from "../../core/components/checkBox";
import { DatePicker } from "../../core/components/datePicker";
import { RecurringTaskEntity } from "./recurringTask";
import InheritedValueComment from "../InheritedValueComment";
import { Metadata } from "../../core/components/commonApp";
import React from "react";

export default class RecurrenceSchemaApp extends React.Component<RecurrenceSchemaProps, RecurrenceSchemaState>{

    private factory = ComponentHelper.createFactory();
    workPackagesDs = [];
    executionTypeDs = [];
    private oldWorkPackageId;
    private oldWorkPackageTitle;
    private oldWorkPageLength;
    private selectedSchemIndex;
    private isLocked;
    common = new AppHelper();
    constructor(props: RecurrenceSchemaProps) {
        super(props);
        this.common.init(this);
        this.selectedSchemIndex = 0;
        this.fillExecutionTypeDs();
        this.state = { showSchemaOnce: props.entity.RecurrenceSchema.Type === 'RecurrenceSchemaOnceViewModel' };
        if (!this.state.showSchemaOnce)
            this.selectedSchemIndex = props.entity.RecurrenceSchema?.SchemaList.length - 1;
        this.isLocked = Helper.hasValue(props.entity.LockMessage)
        this.reloadWorkPackages(props.entity.WorkPackages);
    }

    private fillExecutionTypeDs = () => {
        this.executionTypeDs.push({ Key: ExecutionType.Once, Value: Helper.getTranslation("WebCRM.Tasks.Task.Once") });
        this.executionTypeDs.push({ Key: ExecutionType.Chain, Value: Helper.getTranslation("WebCRM.Tasks.Task.Recurring") });
    }
    private getNumericTextBoxMaxExecutionsBoxProps = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.disabled = this.props.entity.MergedProps.State.Value > TaskState.Draft || !this.props.entity.RecordRight.CanWrite;
        props.value = this.props.entity.RecurrenceSchema.MaxExecutions;
        props.onChange = this.onComponentChange;
        props.field.model = "MaxExecutions";
        return props;
    }
    private getStartingPointProps = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.disabled = this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex].Triggered || !this.props.entity.RecordRight.CanWrite;
        props.value = this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex]?.StartingPoint;
        props.onChange = this.onComponentChange;
        props.field.dataSourceUrl = "RecurringTask/GetStartingPoints";
        props.field.dataTextField = "Title";
        props.field.dataValueField = "Value";
        props.field.model = "StartingPoint";
        props.field.defaultValue = 1;
        return props;
    }
    private getRoundStartToUnitProps = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.disabled = this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex].Triggered || !this.props.entity.RecordRight.CanWrite;
        props.value = this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex]?.RoundStartToUnit;
        props.onChange = this.onComponentChange;
        props.field.dataSourceUrl = "RecurringTask/GetPeriodUnits";
        props.field.dataTextField = "Title";
        props.field.dataValueField = "Value";
        props.field.model = "RoundStartToUnit";
        props.field.defaultValue = 1;
        return props;
    }
    private getWorkpackageId = () => {
        let workpackageId;
        if (this.state.showSchemaOnce) {
            workpackageId = this.props.entity.RecurrenceSchema.WorkPackageId;
        } else if (Helper.hasValue(this.state.workPackageIndex)) {
            workpackageId = this.workPackagesDs[this.state.workPackageIndex].Key;
        } else {
            workpackageId = this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex].WorkPackageId;
        }
        return Helper.hasValue(workpackageId) ? workpackageId : this.oldWorkPackageId;
    }
    private getWorkpackageTitle = () => {
        let title=this.workPackagesDs.filter(x=> x.Key == this.getWorkpackageId())[0].Title;
       return Helper.hasValue(title)? title : this.oldWorkPackageTitle;
    }
    private getRecSchemaTriggered = () => {
        if (this.state.showSchemaOnce) {
            return this.props.entity.RecurrenceSchema.Triggered || !this.props.entity.RecordRight.CanWrite;
        } else {
            return (this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex].Triggered || !this.props.entity.RecordRight.CanWrite);
        }
    }
    private keyIdForRefresh = kendo.guid();// WorkAround, da die datasource nicht neu gesetzt wird in der Komponente
    private getWorkPackageProps = () => {
        if (!Helper.hasValue(this.oldWorkPackageId) || this.oldWorkPackageId != this.getWorkpackageId() || this.props.entity.WorkPackages.length != this.oldWorkPageLength || this.oldWorkPackageTitle != this.getWorkpackageTitle()) {
            this.reloadWorkPackages(this.props.entity.WorkPackages);
            this.oldWorkPageLength = this.props.entity.WorkPackages.length;
            this.keyIdForRefresh = kendo.guid();
        }
        const props = this.factory.getDefaultDropDownProps();
        props.onDataLoaded = () => { };
        props.disabled = this.getRecSchemaTriggered();
        props.value = this.getWorkpackageId();
        props.onChange = this.onComponentChange;
        props.dataSource = this.props.entity.WorkPackages.map((i) => { return { Key: i.Id, Value: i.Title } });
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.model = "WorkPackageId";
        props.field.refreshDSOnRefChange = true;
        props.required = false;
        props.commandManager = this.props["commandManager"];
        props["key"] = this.keyIdForRefresh;
        return props;
    }
    private getPeriodeProps = () => {
        const props = this.factory.getDefaultNodaPeriodNumericProps();
        props.disabled = this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex].Triggered || !this.props.entity.RecordRight.CanWrite;
        props.value = this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex]?.Period;
        props.onChange = this.onComponentChange;
        props.field.model = "Period";
        props.field.defaultValue = 1;
        return props;
    }
    private getStartProps = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.disabled = this.props.entity.MergedProps.State.Value > TaskState.Draft || !this.props.entity.RecordRight.CanWrite;
        props.value = this.props.entity.MergedProps.StartsOn;
        props.onChange = this.onComponentChange;
        props.field.model = "entity.MergedProps.StartsOn";
        props.field.clearTime = true;
        return props;
    }
    private getEndProps = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.disabled = this.props.entity.MergedProps.State.Value == TaskState.Active || !this.props.entity.RecordRight.CanWrite;
        props.value = this.props.entity.MergedProps.EndsOn;
        props.onChange = this.onComponentChange;
        props.field.model = "entity.MergedProps.EndsOn";
        props.field.clearTime = true;
        return props;
    }
    private getExecutionTypeProps = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.onDataLoaded = () => {};
        props.disabled = this.props.entity.MergedProps.State.Value > TaskState.Draft || !this.props.entity.RecordRight.CanWrite;
        props.value = (this.props.entity.RecurrenceSchema.Type === 'RecurrenceSchemaOnceViewModel') ? ExecutionType.Once : ExecutionType.Chain;
        props.onChange = this.onComponentChange;
        props.dataSource = this.executionTypeDs;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.model = "Execution";
        props.field.defaultValue = 1;
        return props;
    }
    private onComponentChange = (field, value) => {
        switch (field.model) {
            case "StartingPoint":
                this.props.onChange({ model: `entity.RecurrenceSchema.SchemaList[${this.selectedSchemIndex}].StartingPoint` }, value);
                break;
            case "TriggerOnInit":
                this.props.onChange({ model: "entity.TriggerOnInit" }, value);
                break;
            case "entity.MergedProps.StartsOn":
                this.props.onChange({ model: "entity.MergedProps.StartsOn" }, value);
                break;
            case "entity.MergedProps.EndsOn":
                this.props.onChange({ model: "entity.MergedProps.EndsOn" }, value);
                break;
            case "MaxExecutions":
                this.props.onChange({ model: "entity.RecurrenceSchema.MaxExecutions" }, value);
                break;
            case "RoundStartToUnit":
                this.props.onChange({ model: `entity.RecurrenceSchema.SchemaList[${this.selectedSchemIndex}].RoundStartToUnit` }, value);
                break;
            case "Period":
                this.props.onChange({ model: `entity.RecurrenceSchema.SchemaList[${this.selectedSchemIndex}].Period` }, value);
                break;
            case "WorkPackageId":
                if (this.state.showSchemaOnce) {
                    this.props.onChange({ model: "entity.RecurrenceSchema.WorkPackageId" }, value);
                } else {
                    this.props.onChange({ model: `entity.RecurrenceSchema.SchemaList[${this.selectedSchemIndex}].WorkPackageId` }, value);
                }
                break;
            case "Execution":
                if (value === ExecutionType.Once) {
                    this.props.onChange({ model: "entity.RecurrenceSchema.IsNew" }, true);
                    this.props.onChange({model: "entity.RecurrenceSchema.Type" }, "RecurrenceSchemaOnceViewModel");
                    this.setState({ showSchemaOnce: true });
                } else if (value === ExecutionType.Chain) {
                    this.props.onChange({ model: "entity.RecurrenceSchema.Type" }, "RecurrenceSchemaChainViewModel");
                    if (!Helper.hasValue(this.props.entity.RecurrenceSchema.SchemaList)) {
                        this.props.onChange({ model: "entity.RecurrenceSchema.IsNew" }, true);
                        this.props.onChange({ model: "entity.RecurrenceSchema.SchemaList" },
                            [{ IsNew: true, MaxExecutions: null, Period: "", TriggerFromValidFrom: false, RoundStartToUnit: 8, StartingPoint: 1, Type: "RecurrenceSchemaAllXViewModel", WorkPackageId: this.props.entity.RecurrenceSchema.WorkPackageId }]);
                    }

                    this.setState({ showSchemaOnce: false });
                }
        }

    }
    reloadWorkPackages = (ds) => {
        this.workPackagesDs.length = 0;
        for (let i = 0; i < ds.length; i++) {
            this.workPackagesDs.push({ Key: ds[i].Id, Value: ds[i].Title });
        }
        this.oldWorkPageLength = ds.length;
        if (this.workPackagesDs.length === 1) {
            if (!Helper.hasValue(this.oldWorkPackageId)) {
                this.oldWorkPackageId = this.getWorkpackageId();
                this.oldWorkPageLength = ds.length;
                
            }
            if (this.oldWorkPackageId !== this.workPackagesDs[0].Key) {
                this.oldWorkPackageId = this.workPackagesDs[0].Key;
                this.oldWorkPackageTitle= this.workPackagesDs.filter(x=> x.Key == this.getWorkpackageId())[0].Title;
            }
        }
    }
    private getTriggerOnInitProps = () => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.disabled = this.props.entity.MergedProps.State.Value > TaskState.Draft || !this.props.entity.RecordRight.CanWrite;
        props.value = this.props.entity.TriggerOnInit;
        props.onChange = this.onComponentChange;
        props.field.model = "TriggerOnInit";
        return props;
    }

    private newVersion = async () => {
        const sheet = General.Sheet.Manager.createSheet();
        const saveResult = await HTTPService.post("RecurringTask/Save", { model: {...this.props.entity, Machines: [], WorkPackages: []}, lockId: this.props.entity.IsId });
        if (saveResult.Code === 0) {
            Helper.updateEntity(this.props.entity, saveResult.Data);
            this.reloadWorkPackages(this.props.entity.WorkPackages);
            this.setState({ workPackageIndex: null });
            let topSheet = General.Sheet.Manager.getTopMostVisibleSheet();
            topSheet.trigger(SheetEventType.Custom, { command: "render" });
            let result = await HTTPService.get<JsonResultClass<EditRecurrenceSchemaEntity>>("RecurringTask/InitNewSchemaVersionForTask?id=" + encodeURIComponent(this.props.entity.Id));
            sheet.show(() => {
                const assignmentInfo = result.Data;
                assignmentInfo.TriggeredCount = this.props.entity.TriggeredCount;
                assignmentInfo.RecordRight = { CanWrite: this.props.entity.RecordRight.CanWrite, CanRead: this.props.entity.RecordRight.CanRead };
                const props: EditReccurenceSchemaProps = {
                    entity: assignmentInfo,
                    context: { },
                    dataSources: { workpackageDs: this.workPackagesDs },
                    isWindow: true,
                    title: "",
                    metadata: {} as Metadata
                };
                sheet.setTitle(Helper.getTranslation("WebCRM.Tasks.Title.CycleAdjustment"));
                sheet.mountContent(EditRecurrenceSchemaVersion, props);

            });
            sheet.bind(SheetEventType.SavedSuccessfully, async  (data: any) => {
                
                let result = await HTTPService.post("RecurringTask/AddNewSchemaVersionForTask", { id: encodeURIComponent(this.props.entity.Id), newVersion: data.data, lockId: this.props.entity.IsId });
                if (result.Code === 0) {
                    let result = await HTTPService.get("RecurringTask/Init?id=" + this.props.entity.Id);
                    Helper.updateEntity(this.props.entity, result.Data);
                    this.selectedSchemIndex++;
                    this.oldWorkPackageId = this.getWorkpackageId();
                    let oldWorkPackage = this.workPackagesDs.filter(x => x.Key == this.oldWorkPackageId)[0];
                    let oldWorkPackageIndex = this.workPackagesDs.indexOf(oldWorkPackage);
                    this.setState({ workPackageIndex: oldWorkPackageIndex }, () => {
                        this.setState({ workPackageIndex: null });
                    });
                }

                sheet.hide();
            });

        }
    }
    private getDatePickerScheduledFor = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.disabled = true;
        props.value = this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex].ValidFrom;
        props.onChange = this.onComponentChange;
        props.field.model = "NewVersionValidFrom";
        props.field.clearTime = true;
        return props;
    }

    private getValidFromCheck = () => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.disabled = true;
        props.value = this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex].TriggerFromValidFrom;
        props.onChange = this.onComponentChange;
        props.field.model = "validFormCheck";
        return props;
    }
    private getPreviousSchema = () => {
        this.selectedSchemIndex--;
        this.setState({});
    }
    private getNextSchema = () => {
        this.selectedSchemIndex++;
        this.setState({});
    }
    render() {
        let versionNo = this.selectedSchemIndex + 1;
        // zum ValidFrom gehört noch der Hacken // "ExecuteAtValidFrom"
        const validFrom = (!this.state.showSchemaOnce && this.selectedSchemIndex > 0 && this.props.entity.TriggeredCount > 0) 
            ? (<>
                <FieldInstance label={Helper.getTranslation("Field.fstasks.ValidFrom")}>
                    <DatePicker  {... this.getDatePickerScheduledFor()} />
                </FieldInstance>
              </>) 
            :  null;
        const validFromCheck = (!this.state.showSchemaOnce && this.selectedSchemIndex > 0 && this.props.entity.TriggeredCount > 0) 
            ? (<>
                <FieldInstance label={Helper.getTranslation("Field.fstasks.TriggerOnInit.NewSchema")}>
                    <CheckBox  {... this.getValidFromCheck()} />
                </FieldInstance>
               </>) 
            : null;
        const prevButton =
            (<>
                <Button
                    iconName="arrow-up"
                    handleClick={this.getPreviousSchema}
                    text={"Vorherige Version"}
                    buttonStyle={{
                        width: "49%",
                        height: "30px",
                        border: "solid 1px #bdbdbd",
                        margin: "0 2% 0 0"
                    }}
                    readOnly={this.selectedSchemIndex == 0}
                />
            </>);
        const nextButton =
            (<>
                <Button
                    iconName="arrow-down"
                    handleClick={this.getNextSchema}
                    text={"Nächste Version"}
                    buttonStyle={{
                        width: "49%",
                        height: "30px",
                        border: "solid 1px #bdbdbd"
                    }}
                    readOnly={!this.state.showSchemaOnce && this.selectedSchemIndex + 1 == this.props.entity.RecurrenceSchema.SchemaList.length}
                />
            </>);
        const dropDownExecution = (
            <>
                <FieldInstance label={Helper.getTranslation("Field.fstasks.CycleType")}>
                    <DropDownList  {... this.getExecutionTypeProps()} />
                </FieldInstance>
            </>);
        var startLabelText = this.getExecutionTypeProps().value == ExecutionType.Once
            ? Helper.getTranslation("Field.fstasks.ExecutionOn") 
            : Helper.getTranslation("Auftrag.Start");
        const startDateComp = (
            <>  
                <FieldInstance label={startLabelText}> 
                    <DatePicker {... this.getStartProps()} />
                    <InheritedValueComment entity={this.props.entity} fieldModel={this.getStartProps().field.model} readOnly="!entity.RecordRight.CanWrite || entity.MergedProps.State.Value > 0" />
                </FieldInstance>
            </>);
        const checkBoxTriggerOnInt = (!this.state.showSchemaOnce) 
            ? (
                <FieldInstance label={Helper.getTranslation("WebCRM.Tasks.RecurringTask.ExecutionAtStart")}>
                    <CheckBox  {... this.getTriggerOnInitProps()} />
                </FieldInstance>) 
            : null;
        const endDate = (!this.state.showSchemaOnce) 
            ? (
                <FieldInstance label={Helper.getTranslation("Field.fstasks.EndsAt")}>
                    <DatePicker  {... this.getEndProps()} />
                    <InheritedValueComment entity={this.props.entity} fieldModel={this.getEndProps().field.model}  readOnly="!entity.RecordRight.CanWrite || entity.MergedProps.State.Value > 0"/>
                </FieldInstance>
              ) 
            : null;
        var lastExecutionOn = Helper.getTranslation("Field.fstasks.LastExecutionOn").replace("{Date}", kendo.toString(kendo.parseDate(this.props.entity.LastExecutionOn), 'd') + ' (#' + this.props.entity.TriggeredCount + ')');
        const lastExecution = (!this.state.showSchemaOnce && this.props.entity.TriggeredCount > 0) 
            ? (
                <FieldInstance noLabel={true}>
                    <label style={{ marginLeft: '5px' }}>{lastExecutionOn}</label>
                </FieldInstance>) 
            : null;
        const maxExecutions = (!this.state.showSchemaOnce) 
            ? (
                <FieldInstance label={Helper.getTranslation("Field.fstasks.MaxExecutions")}>
                    <IsNumericTextBox  {... this.getNumericTextBoxMaxExecutionsBoxProps()} />
                </FieldInstance>) 
            : null;
        var version = Helper.getTranslation("Field.fstasks.CycleVersion").replace("{Version}", versionNo);
        const lableHeadline = (!this.state.showSchemaOnce) 
            ? (this.props.entity.TriggeredCount > 0 && this.props.entity.RecurrenceSchema.SchemaList.length > 1) 
                ? (
                    <>
                        <FieldInstance label={version}>
                            {prevButton}
                            {nextButton}
                        </FieldInstance>
                    </>)
                : (
                    <>
                        <FieldInstance label={version}>
                        </FieldInstance>
                    </>)
            : (
                <label style={{ marginLeft: '5px' }} > {Helper.getTranslation("WebCRM.Tasks.Task.Once")}</label>
              );
        const dropDownWorkpackage = (
            <> 
                <FieldInstance required={false} label={Helper.getTranslation("WebCRM.Tasks.Title.Workpackage")}>
                    <DropDownList  {... this.getWorkPackageProps()} />
                </FieldInstance>
            </>);
        const elementOnlyChain = (!this.state.showSchemaOnce) 
            ? (<>
                <FieldInstance label={Helper.getTranslation("Field.fstasks.StartingPoint")}>
                    <DropDownList  {... this.getStartingPointProps()} />
                </FieldInstance>
                <FieldInstance required={true} label={Helper.getTranslation("WebCRM.Tasks.RecurringTask.WorklogInterval")}>
                    <NodaPeriodeNumericTextBox  {... this.getPeriodeProps()} />
                </FieldInstance>
                <FieldInstance label={Helper.getTranslation("Field.fstasks.RoundStartToUnit")}>
                    <DropDownList  {... this.getRoundStartToUnitProps()} />
                </FieldInstance>
            </>) 
            : null;
        const buttonNewVersion = (!this.state.showSchemaOnce) 
            ? (
                <Button
                    iconName="plus"
                    handleClick={this.newVersion}
                    text={Helper.getTranslation("WebCRM.Tasks.Task.Schema.NewVersion.Btn")}
                    buttonStyle={{
                        width: "33%",
                        height: "30px",
                        border: "solid 1px #bdbdbd",
                        margin: "1px"
                    }}
                    readOnly={((!this.props.entity.RecurrenceSchema.SchemaList[this.selectedSchemIndex].Triggered || this.props.entity.RecurrenceSchema.SchemaList.length != this.selectedSchemIndex + 1) || !this.props.entity.RecordRight.CanWrite || this.props.entity.MergedProps.State.Value>TaskState.Active)}
                    />) 
            : null;
        const input = (
            <>
                <div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '5px' }}>
                        {dropDownExecution}
                        {startDateComp}
                        {checkBoxTriggerOnInt}
                        {endDate}
                        {lastExecution}
                        {maxExecutions}
                        {lableHeadline}
                        {validFrom}
                        {validFromCheck}
                        {elementOnlyChain}
                        {dropDownWorkpackage}
                        {buttonNewVersion}
                    </div>
                </div></>);
        return (<>{input}</>);
    }


}
export interface RecurrenceSchemaState {
    showSchemaOnce?: boolean;
    workPackageIndex?:number;
}
export interface RecurrenceSchemaProps {
    entity: RecurringTaskEntity;
    onChange: any;
    context: { }

}
export interface RecurenceSchemaEntity {
    Id: string;
    MaxDuration: number;
    MaxExecutions: number;
    TriggerOnInit: boolean;
    Triggered: boolean;
    Type: string;
    WorkPackageId: string;
    SchemaList: Array<RecurenceSchemaEntity>;
    StartingPoint: number;
    RoundStartToUnit: number;
    Period: string;
    ValidFrom: string;
    TriggerFromValidFrom: boolean;

}
enum ExecutionType {
    Once,
    Chain
}
enum TaskState {
    Draft,
    Active,
    Finished,
    Cancelled
}